import React from 'react';

const NoFound = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        color: '#343a40'
    }}>
        <div>
            <h1 style={{ fontSize: '72px' }}>404</h1>
            <p style={{ fontSize: '24px' }}>Oops! The page you are looking for does not exist.</p>
            <a href="/" style={{
                display: 'inline-block',
                marginTop: '20px',
                padding: '10px 20px',
                fontSize: '18px',
                textDecoration: 'none',
                color: 'white',
                backgroundColor: '#007bff',
                borderRadius: '5px'
            }}>
                Go Back Home
            </a>
        </div>
    </div>
);

export default NoFound;
